import { Injectable } from '@angular/core';
import { CommonService } from '../common/common.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SessionStorageKey } from 'src/app/enums/session-storage-key-enum';
import { ModalWifiSecurityLocationNoticeComponent } from 'src/app/components/modal/modal-wifi-security-location-notice/modal-wifi-security-location-notice.component';
import { ModalHomeProtectionLocationNoticeComponent } from 'src/app/components/modal/modal-home-protection-location-notice/modal-home-protection-location-notice.component';
import { EventTypes, WifiSecurity } from '@lenovo/tan-client-bridge-le';
import { ModalErrorMessageComponent } from 'src/app/components/modal/modal-error-message/modal-error-message.component';
import { LocalStorageKey } from 'src/app/enums/local-storage-key.enum';
import { ModalModernPreloadComponent } from 'src/app/components/modal/modal-modern-preload/modal-modern-preload.component';
import { Router } from '@angular/router';
import { DeviceService } from '../device/device.service';
import { ModalLicenseAgreementComponent } from 'src/app/components/modal/modal-license-agreement/modal-license-agreement.component';
import { AdPolicyService } from '../ad-policy/ad-policy.service';
import { AdPolicyId } from 'src/app/enums/ad-policy-id.enum';
import { MetricsService } from '../metrics/metrics.service';

@Injectable({
	providedIn: 'root'
})
export class DialogService {
	constructor(
		private commonService: CommonService,
		public modalService: NgbModal,
		private router: Router,
		private deviceService: DeviceService,
		private adService: AdPolicyService,
		private metricsService: MetricsService,

	) { }

	wifiSecurityLocationDialog(wifiSecurity: WifiSecurity) {
		if (this.modalService.hasOpenModals()) {
			return;
		}
		if (this.commonService.getSessionStorageValue(SessionStorageKey.SecurityWifiSecurityInWifiPage) || this.commonService.getSessionStorageValue(SessionStorageKey.SecurityWifiSecurityInGamingDashboard)) {
			this.commonService.setSessionStorageValue(SessionStorageKey.SecurityWifiSecurityLocationFlag, 'no');
			const modal = this.modalService.open(ModalWifiSecurityLocationNoticeComponent,
				{
					backdrop: 'static'
					, windowClass: 'wifi-security-location-modal'
				});
			modal.componentInstance.header = 'security.wifisecurity.locationmodal.title';
			modal.componentInstance.description = 'security.wifisecurity.locationmodal.describe1';
			modal.componentInstance.url = 'ms-settings:privacy-location';
			modal.componentInstance.wifiSecurity = wifiSecurity;
			modal.componentInstance.closeButtonId = 'sa-ws-btn-locationClose';
			modal.componentInstance.agreeButtonId = 'sa-ws-btn-locationAgree';
			modal.componentInstance.cancelButtonId = 'sa-ws-btn-locationCancel';
			wifiSecurity.on(EventTypes.wsIsLocationServiceOnEvent, (para) => {
				if (para) {
					modal.close(true);
				}
			});
			modal.result.then((res) => {
				if (res === 'cancelClick' && wifiSecurity && wifiSecurity.state === 'enabled') {
					wifiSecurity.disableWifiSecurity();
				}
			});
		}
	}

	wifiSecurityErrorMessageDialog() {
		if (this.modalService.hasOpenModals()) {
			return;
		}
		if (this.commonService.getSessionStorageValue(SessionStorageKey.SecurityWifiSecurityInWifiPage)) {
			const showdialog = this.commonService.getSessionStorageValue(SessionStorageKey.SecurityWifiSecurityShowPluginMissingDialog, true);
			if (showdialog) {
				this.commonService.setSessionStorageValue(SessionStorageKey.SecurityWifiSecurityShowPluginMissingDialog, false);
				const errorMessageModal = this.modalService.open(ModalErrorMessageComponent, {
					backdrop: 'static',
					size: 'lg',
					windowClass: 'wifi-security-error-modal'
				});
				errorMessageModal.componentInstance.header = 'security.wifisecurity.errorMessage.headerText';
				errorMessageModal.componentInstance.description = 'security.wifisecurity.errorMessage.bodyText';
				errorMessageModal.componentInstance.closeButtonId = 'sa-ws-btn-errorMessageDialogClose';
				errorMessageModal.componentInstance.cancelButtonId = 'sa-ws-btn-errorMessageDialogCansole';
			}
		}
	}

	homeProtectionOpenLocationDialog(wifiSecurity: WifiSecurity) {
		if (this.modalService.hasOpenModals()) {
			return;
		}
		if (this.commonService.getSessionStorageValue(SessionStorageKey.SecurityWifiSecurityInWifiPage)) {
			const modal = this.modalService.open(ModalHomeProtectionLocationNoticeComponent,
				{
					backdrop: 'static'
					, windowClass: 'wifi-security-location-modal'
				});
			modal.componentInstance.header = 'security.wifisecurity.locationmodal.title';
			modal.componentInstance.description = 'security.wifisecurity.locationmodal.describe2';
			modal.componentInstance.url = 'ms-settings:privacy-location';
			modal.componentInstance.wifiSecurity = wifiSecurity;
			// modal.componentInstance.closeButtonId = 'sa-ws-btn-locationclose';
			// modal.componentInstance.agreeButtonId = 'sa-ws-btn-locationagree';
			// modal.componentInstance.cancelButtonId = 'sa-ws-btn-locationcancel';
			wifiSecurity.on(EventTypes.wsIsLocationServiceOnEvent, (para) => {
				if (para) {
					modal.close();
				}
			});
		}
	}

	homeSecurityPluginMissingDialog() {
		if (this.modalService.hasOpenModals()) {
			return;
		}

		if (this.commonService.getSessionStorageValue(SessionStorageKey.HomeProtectionInCHSPage)) {
			const errorMessageModal = this.modalService.open(ModalErrorMessageComponent, {
				backdrop: 'static',
				centered: true,
				windowClass: 'home-security-plugin-missing-modal'
			});
			errorMessageModal.componentInstance.header = 'security.wifisecurity.errorMessage.headerText';
			errorMessageModal.componentInstance.description = 'security.wifisecurity.errorMessage.bodyText';
			errorMessageModal.componentInstance.closeButtonId = 'chs-btn-errorMessageDialogClose';
			errorMessageModal.componentInstance.cancelButtonId = 'chs-btn-errorMessageDialogCancle';
			errorMessageModal.result.then(() => {
				this.commonService.setSessionStorageValue(SessionStorageKey.HomeSecurityShowPluginMissingDialog, 'finish');
			});
		}
	}

	homeSecurityOfflineDialog() {
		if (this.modalService.hasOpenModals()) {
			return;
		}
		if (this.commonService.getSessionStorageValue(SessionStorageKey.HomeProtectionInCHSPage)) {
			const errorMessageModal = this.modalService.open(ModalErrorMessageComponent, {
				backdrop: 'static',
				centered: true,
				windowClass: 'home-security-offline-modal'
			});
			errorMessageModal.componentInstance.header = 'security.wifisecurity.errorMessage.headerText';
			errorMessageModal.componentInstance.description = 'security.wifisecurity.errorMessage.offlineText';
			errorMessageModal.componentInstance.closeButtonId = 'chs-btn-offlineDialogClose';
			errorMessageModal.componentInstance.cancelButtonId = 'chs-btn-offlineDialogcancle';
		}
	}

	homeSecurityAccountDialog() {
		if (this.modalService.hasOpenModals()) {
			return;
		}
		if (this.commonService.getSessionStorageValue(SessionStorageKey.HomeProtectionInCHSPage)) {
			const errorMessageModal = this.modalService.open(ModalErrorMessageComponent, {
				backdrop: 'static',
				size: 'lg',
				windowClass: 'home-security-error-modal'
			});
			errorMessageModal.componentInstance.header = 'security.wifisecurity.errorMessage.headerText';
			errorMessageModal.componentInstance.description = 'security.wifisecurity.errorMessage.accountText';
			errorMessageModal.componentInstance.closeButtonId = 'chs-btn-accountDialogClose';
			errorMessageModal.componentInstance.cancelButtonId = 'chs-btn-accountDialogcancle';
		}
	}

	showLicenseAgreementDialog() {
		if (this.commonService.getLocalStorageValue(LocalStorageKey.LicenseAgreementAccepted)) {
			return;
		}

		const skipEulaSetting = this.adService.getPolicyValueByIdSync(AdPolicyId.AcceptEULAAutomatically);
		const skipEula = skipEulaSetting === '1' || skipEulaSetting === 'true';
		if (skipEula) {
			this.commonService.setLocalStorageValue(LocalStorageKey.LicenseAgreementAccepted, true);
			this.metricsService.sendAppActivationEvent();
			return;
		}

		if (this.modalService.hasOpenModals()) {
			return;
		}

		const licenseAgreementModal = this.modalService.open(ModalLicenseAgreementComponent, {
			backdrop: 'static',
			centered: true,
			windowClass: 'license-agreement-modal'
		});

		licenseAgreementModal.result.catch(() => {	// window dismiss
			const win: any = window;
			if (win.VantageStub && win.VantageStub.exitApp) {
				win.VantageStub.exitApp();
			}
		});
	}

	openModernPreloadModal() {
		if (this.modalService.hasOpenModals()) { return; }
		const modernPreloadModal: NgbModalRef = this.modalService.open(ModalModernPreloadComponent, {
			backdrop: 'static',
			size: 'lg',
			centered: true,
			windowClass: 'modern-preload-modal',
			keyboard: false,
			beforeDismiss: () => {
				if (modernPreloadModal.componentInstance.onBeforeDismiss) {
					modernPreloadModal.componentInstance.onBeforeDismiss();
				}
				return true;
			}
		});
	}
}
